import React from 'react';
import {
  GlobeAltIcon,
  TruckIcon,
  ExclamationTriangleIcon,
  ClockIcon,
  FilmIcon,
  ShieldCheckIcon,
  ArrowPathIcon,
  SignalIcon,
  WrenchScrewdriverIcon,
} from '@heroicons/react/24/outline';
import { IndustryPageTemplate } from '../../components/page-templates/MarketPageTemplates';

const challenges = [
  {
    icon: ClockIcon,
    title: 'Time-Critical Delivery',
    description: 'Productions and live events operate on fixed schedules with zero tolerance for equipment delays.',
  },
  {
    icon: ExclamationTriangleIcon,
    title: 'High-Value Specialised Equipment',
    description: 'Cameras, broadcast gear, and production hardware demand careful handling and comprehensive insurance.',
  },
  {
    icon: GlobeAltIcon,
    title: 'Global Distribution',
    description: 'Studios, remote shoots, and post-production facilities spanning continents require seamless delivery.',
  },
  {
    icon: ArrowPathIcon,
    title: 'Rapid Deployment Cycles',
    description: 'Quick turnaround between deployment and decommissioning as productions wrap and new ones begin.',
  },
];

const solutions = [
  {
    icon: TruckIcon,
    title: 'White Glove Delivery',
    description: 'Handled-with-care logistics for high-value production and broadcast equipment worldwide.',
  },
  {
    icon: ClockIcon,
    title: 'Time-Critical SLAs',
    description: '8, 12, and 24-hour delivery windows to meet the demanding timelines of live and studio productions.',
  },
  {
    icon: ShieldCheckIcon,
    title: 'USD 3M Cargo Insurance',
    description: 'Global freight coverage protecting your most valuable production and broadcast equipment in transit.',
  },
  {
    icon: WrenchScrewdriverIcon,
    title: 'Staging & Configuration',
    description: 'Pre-configuration of broadcast and production hardware so equipment is ready to use on arrival.',
  },
  {
    icon: ArrowPathIcon,
    title: 'Reverse Logistics',
    description: 'Equipment recovery after productions wrap, with global pickup and return to any location.',
  },
  {
    icon: SignalIcon,
    title: 'Real-Time Tracking',
    description: 'Full shipment visibility so production managers always know where their equipment is.',
  },
];

const stats = [
  { value: '140+', label: 'Countries' },
  { value: '6', label: 'Global Offices' },
  { value: '10+', label: 'Years Experience' },
  { value: '6,500+', label: 'Field Workers' },
];

const MediaEntertainment: React.FC = () => (
  <IndustryPageTemplate
    eyebrow="Media & Entertainment"
    title="ICT Logistics for Media & Entertainment Technology"
    highlight="Media & Entertainment"
    description="Supporting global content creation and distribution with reliable, time-sensitive ICT equipment logistics."
    heroIcon={FilmIcon}
    heroAccentIcon={GlobeAltIcon}
    challengesIntro="Media and entertainment companies face unique time pressures and equipment handling demands."
    challenges={challenges}
    solutionsIntro="Time-critical execution designed for production windows, specialized gear, and global studio operations."
    solutions={solutions}
    useCase="Whether you are equipping a new studio, supporting a live broadcast, or managing post-production infrastructure, TrueLog delivers the speed and care your equipment demands."
    stats={stats}
    ctaTitle="Ready to power your productions with reliable logistics?"
    ctaDescription="Let TrueLog deliver the speed and care your media technology requires, anywhere in the world."
  />
);

export default MediaEntertainment;
